import { render } from "./uiAnnouncementBar.vue?vue&type=template&id=3ff77e72"
import script from "./uiAnnouncementBar.vue?vue&type=script&lang=js"
export * from "./uiAnnouncementBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__